import React from 'react';

import { Button } from '@/components/global/Button';

import { TCard } from '@/services/requests/Recommendation/types/template4';

import { getCTA } from '@/helpers/CtaHelper';
import { getValue } from '@/helpers/GetValueHelper';

type TModalTitleProps = {
  data: TCard;
};

export const ModalContent = ({ data }: TModalTitleProps) => {
  const cta = getCTA(data.cta, 'web');
  const buttonInfo = {
    link: getValue(cta, 'link', '') as string,
    text: data.info_modal.cta_label,
  };

  const handlerOnClick = () => {
    window.location.assign(buttonInfo.link);
  };

  return (
    <>
      <section
        className="vitrine-template4__modal-description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: getValue(
            data,
            'info_modal.modal_title.modal_description',
            '',
          ) as string,
        }}
      />
      {buttonInfo.text && (
        <Button
          className="vitrine-template4__modal-button"
          text={buttonInfo.text}
          onClick={handlerOnClick}
        />
      )}
    </>
  );
};
